TripItemBusService.SERVICE_NAME = 'tripItemBusService';

export default function TripItemBusService() {
    Object.assign(this, {
        getFromToRoute,
        getDepartureDate,
    });

    function getFromToRoute(recommendation) {
        const firstBus = getFirstBus(recommendation);
        const lastBus = getLastBus(recommendation);

        return `${firstBus.From} &rarr; ${lastBus.To}`;
    }

    function getFirstBus(recommendation) {
        return recommendation
            && recommendation.BusesInfo
            && recommendation.BusesInfo[0];
    }

    function getLastBus(recommendation) {
        const count = recommendation
            && recommendation.BusesInfo
            && recommendation.BusesInfo.length;
        return count && recommendation.BusesInfo[count - 1];
    }

    function getDepartureDate(recommendation) {
        return recommendation
            && recommendation.BusesInfo
            && recommendation.BusesInfo[0]
            && recommendation.BusesInfo[0].DepartureDate;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-item-bus/trip-item-bus-service.js